// Generated by tools/as3-to-ts from work/decomp/main/scripts/com/ProtectedInt.as; hand-edits allowed (see docs/architecture.md)

import * as as3 from '../runtime/as3';

export class ProtectedInt {
  private static readonly MIN_MIX: number = -48151;
  private static readonly MAX_MIX: number = 62342;
  private val: number = 0;
  private mix: number = 0;

  constructor(param1: number = 0) {
    param1 = as3.int(param1);
    this.mix = as3.int(Math.floor(ProtectedInt.MIN_MIX + (ProtectedInt.MAX_MIX - ProtectedInt.MIN_MIX) * as3.random()));
    this.val = param1 ^ this.mix;
  }

  get value(): number {
    return this.val ^ this.mix;
  }

  set value(param1: number) {
    param1 = as3.int(param1);
    this.val = param1 ^ this.mix;
  }
}
